import { useNavigate } from 'react-router-dom';

import { ProjectView, WorkspaceView } from '@lemoncloud/codes-goods-api';

export interface WorkspaceNavigationOptions {
    workspace?: WorkspaceView | null;
    project?: ProjectView | null;
}

export const useWorkspaceNavigation = ({ workspace, project }: WorkspaceNavigationOptions) => {
    const navigate = useNavigate();

    const navigateToWorkspace = (targetWorkspaceId?: string) => {
        const workspaceId = targetWorkspaceId || workspace?.id;
        const targetPath = workspaceId ? `/w/${workspaceId}` : '/w';
        navigate(targetPath);
    };

    const navigateToProject = (targetProject: ProjectView) => {
        if (workspace?.id) {
            navigate(`/w/${workspace.id}/p/${targetProject.id}`);
        }
    };

    const navigateToProjectPath = (path: string) => {
        if (workspace?.id && project?.id) {
            navigate(`/w/${workspace.id}/p/${project.id}${path}`);
        }
    };

    const navigateToWorkspacePath = (path: string) => {
        const targetPath = workspace?.id ? `/w/${workspace.id}${path}` : path;
        navigate(targetPath);
    };

    return {
        navigateToWorkspace,
        navigateToProject,
        navigateToProjectPath,
        navigateToWorkspacePath,
    };
};
